import React from "react";

const Notfound = ()=>{
    return (
        <h1>NOT FOUND</h1>
    );
}

export default Notfound;